<template>
  <div class="container-fluid pb-6 pb-8 pt-5 pt-md-8">
    <div class="card-header mt-4">
      <h1>Create Live Stream</h1>
      <hr />
      <form action="#">
        <div class="row">
          <div class="col-md-12">
            <label for="Title">Title</label>
            <span class="error" v-if="!title && !isInputValid"
              >* field required</span
            >
            <!-- <base-input alternative placeholder="Title" v-model="title" /> -->
            <div>
              <div class="relative">
                <base-input alternative placeholder="Title" v-model="title" />

                <emoji-picker @emoji="appendTitle" :search="search">
                  <div
                    class="emoji-invoker"
                    slot="emoji-invoker"
                    slot-scope="{ events: { click: clickEvent } }"
                    @click.stop="clickEvent"
                  >
                    <svg
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path
                        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                      />
                    </svg>
                  </div>
                  <div
                    slot="emoji-picker"
                    slot-scope="{ emojis, insert, display }"
                  >
                    <div
                      class="emoji-picker"
                      :style="{ top: '50px', left: screenWidth - 600 + 'px' }"
                    >
                      <div class="emoji-picker__search">
                        <input type="text" v-model="search" v-focus />
                      </div>
                      <div>
                        <div
                          v-for="(emojiGroup, category) in emojis"
                          :key="category"
                        >
                          <h5>{{ category }}</h5>
                          <div class="emojis">
                            <span
                              v-for="(emoji, emojiName) in emojiGroup"
                              :key="emojiName"
                              @click="insert(emoji)"
                              :title="emojiName"
                              >{{ emoji }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </emoji-picker>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <label for="Description">Description</label>
            <!-- <textarea class="form-control" rows="3" placeholder="Description" v-model="description"></textarea> -->
            <div>
              <div class="relative">
                <textarea
                  class="form-control"
                  rows="3"
                  placeholder="Description"
                  v-model="description"
                ></textarea>

                <emoji-picker @emoji="appendDescription" :search="search">
                  <div
                    class="emoji-invoker"
                    slot="emoji-invoker"
                    slot-scope="{ events: { click: clickEvent } }"
                    @click.stop="clickEvent"
                  >
                    <svg
                      height="24"
                      viewBox="0 0 24 24"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 0h24v24H0z" fill="none" />
                      <path
                        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                      />
                    </svg>
                  </div>
                  <div
                    slot="emoji-picker"
                    slot-scope="{ emojis, insert, display }"
                  >
                    <div
                      class="emoji-picker"
                      :style="{ top: '50px', left: screenWidth - 600 + 'px' }"
                    >
                      <div class="emoji-picker__search">
                        <input type="text" v-model="search" v-focus />
                      </div>
                      <div>
                        <div
                          v-for="(emojiGroup, category) in emojis"
                          :key="category"
                        >
                          <h5>{{ category }}</h5>
                          <div class="emojis">
                            <span
                              v-for="(emoji, emojiName) in emojiGroup"
                              :key="emojiName"
                              @click="insert(emoji)"
                              :title="emojiName"
                              >{{ emoji }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </emoji-picker>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-4">
            <label for="Streaming Server">Streaming Server</label>
            <v-select
              v-model="streamingServer"
              :options="streamingServers"
            ></v-select>
          </div>
          <div class="col-md-12 inline-flex mt-4">
            <base-switch v-model="isWebOnly" />
            <label class="pl-3">Website Only</label>
          </div>
          <div class="col-md-12 inline-flex mt-4">
            <base-switch v-model="hasPollQuestion" />
            <label class="pl-3">Poll Question</label>
          </div>
          <div v-if="hasPollQuestion" class="col-md-4 mt-3">
            <div>
              <label for="Question">Question</label>
              <span class="error" v-if="!pollQuestion">* field required</span>
              <base-input
                alternative
                placeholder="Question"
                v-model="pollQuestion"
              />
            </div>
            <div v-for="(answer, index) in answers" :key="answer.id">
              <label for="Answer">{{ `Answer` + (index + 1) }}</label>
              <button type="button" class="close" @click="removeAnswer">
                <span>×</span>
              </button>
              <base-input
                alternative
                placeholder="Answer"
                v-model="answers[index]"
              />
            </div>
            <base-button outline type="primary" @click="addAnswer" class="mb-3"
              >Add Answer</base-button
            >
            <br />
            <span class="answer-validation" v-if="!validAnswer()"
              >* Answer must be more than 2</span
            >
          </div>
          <div class="col-md-12 text-center">
            <base-button
              type="primary"
              class="btn-create"
              @click="onSubmit()"
              :disabled="isLoading"
              >Create</base-button
            >
            <h4 class="text-danger" v-if="error">* {{ error.message }}</h4>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import EmojiPicker from "vue-emoji-picker";

import { mapState } from "vuex";
import {
  CREATE_LIVE_STREAM,
  UPDATE_LIVE_STREAM_STATUS,
  RESET_COMMENT_STATE
} from "@/store/actions.type";
import { STREAMING_BASE_URL } from "@/common/config";

export default {
  components: {
    vSelect,
    EmojiPicker
  },
  data() {
    return {
      title: "",
      description: "",
      streamingServer: "Local Server",
      streamingServers: ["Local Server"],
      isWebOnly: false,
      pollQuestion: "",
      answers: ["", ""],
      hasImage: false,
      imageUrl: "",
      showModal: false,
      hasPollQuestion: false,
      isInputValid: true,
      search: "",
      screenWidth: 0
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.screenWidth = window.innerWidth;
    },
    addAnswer() {
      this.answers.push("");
    },
    removeAnswer(index) {
      this.answers.pop(index);
    },
    onSubmit() {
      if (this.title) {
        const liveStream = {
          title: this.title,
          description: this.description,
          streamProvider:
            this.streamingServer === "Wowza" ? "wowza" : "ant_media",
          status: "pending",
          useCloud: true,
          isWebOnly: this.isWebOnly
        };
        if (this.hasPollQuestion) {
          const answers = this.answers.filter(answer => answer);
          if (this.pollQuestion && answers.length >= 2) {
            liveStream.pollQuestion = this.pollQuestion;
            liveStream.answers = answers;
            this.$store.dispatch(CREATE_LIVE_STREAM, liveStream).then(() => {
              this.$router.push({ path: `/live_stream/${this.liveStream.id}` });
              this.$store.dispatch(RESET_COMMENT_STATE);
            });
          }
        } else {
          this.$store.dispatch(CREATE_LIVE_STREAM, liveStream).then(() => {
            // this.showModal = true
            this.$router.push({ path: `/live_stream/${this.liveStream.id}` });
            this.$store.dispatch(RESET_COMMENT_STATE);
          });
        }
      } else {
        this.isInputValid = false;
      }
    },
    publish(id) {
      this.$store
        .dispatch(UPDATE_LIVE_STREAM_STATUS, { id: id, status: "live" })
        .then(() => {
          this.$router.push({ path: "/live_stream" });
        });
    },
    close() {
      this.$router.push({ path: "/live_stream" });
    },
    validAnswer() {
      return this.answers.filter(answer => answer).length >= 2;
    },
    appendTitle(emoji) {
      this.title += emoji;
    },
    appendDescription(emoji) {
      this.description += emoji;
    }
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      }
    }
  },
  computed: {
    ...mapState({
      liveStream: state => state.liveStream.currentLiveStream,
      isLoading: state => state.liveStream.isLoading,
      error: state => state.liveStream.error
    })
  }
};
</script>

<style scoped>
.btn-create {
  margin-top: 3rem !important;
  margin-bottom: 1.5rem !important;
  border-radius: 20px !important;
  padding: 0.6rem 2rem !important;
}
hr {
  border-top: 1px solid rgba(225, 225, 225, 0.5) !important;
  margin-top: 0 !important;
}
.card-header {
  border-radius: 15px !important;
  box-shadow: 0 4px 8px 0 rgba(255, 255, 255, 0.2),
    0 6px 20px 0 rgba(92, 92, 92, 0.19);
}
.thumbnail {
  max-width: 100% !important;
}
.btn-flat {
  border: none !important;
}
.inline-flex {
  display: inline-flex;
}

.answer-validation {
  color: #fb6340 !important;
  font-size: 14px;
}

.relative {
  position: relative !important;
}

.inline-block {
  display: inline-block !important;
}

/* .regular-input {
  padding: 0.5rem 1rem;
  border-radius: 3px;
  border: 1px solid #ccc;
  width: 20rem;
  height: 12rem;
  outline: none;
}

.regular-input:focus {
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
} */
</style>
